export default __webpack_public_path__ + "static/media/features-home-bg-01.59a3831d.png";